import axios, { AxiosInstance } from 'axios';
import { decodificarToken } from 'utils/utilities';
import { API_BASE_URL, API_TIMEOUT } from 'services/constants';
import { limpiarLocalStorage } from 'utils/storage/session';

// Crea instancia de Axios
export const axiosInstance: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
});

const SKIP_AUTH_HEADER = 'X-Skip-Auth';

export const setupInterceptors = () => {
  axiosInstance.interceptors.request.use(
    config => {
      const skipAuth = config.headers?.[SKIP_AUTH_HEADER] === 'true';
      const token = localStorage.getItem('token');
      if (token && !skipAuth) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    error => {
      console.error('Error en la solicitud', error);
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      const skipAuth = error.config?.headers?.[SKIP_AUTH_HEADER] === 'true';
      if (error.response?.status === 401 && !skipAuth) {
        limpiarLocalStorage();
        localStorage.setItem('tokenExpirado', 'expirado');
      }
      return Promise.reject(error);
    }
  );
};

export const getSkipAuthHeaders = () => ({
  [SKIP_AUTH_HEADER]: 'true',
});

// SECURITY: tokens are stored in localStorage, which is vulnerable to XSS.
// Migrate to httpOnly cookies when backend supports it.
// Obtener token desde localStorage y evaluar si está expirado
export const getAuthToken = (): string | null => {
  const token = localStorage.getItem('token');
  if (token) {
    try {
      const tokenDecodificado = decodificarToken(token);
      const horaActual = Math.floor(Date.now() / 1000);
      if (typeof tokenDecodificado.exp !== 'number' || tokenDecodificado.exp < horaActual) {
        // Token expirado:
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
        localStorage.setItem('tokenExpirado', 'expirado'); // Si existe este item, da una alerta (en App)
        return null;
      }
      // Token is valid; interceptors on axiosInstance handle the header.
    } catch (error) {
      console.error('Error al decodificar el token:', error);
      localStorage.removeItem('token');
      return null;
    }
  }
  return token;
};
